// Constants.
// -----------------------------------------------------------------------------
export const DEFAULT_ACTION_SCHEMA = 'neutral';
//# sourceMappingURL=ControlledActions.contants.js.map